import { FusaOrganization } from "@/backend/models/fusaOrganization";
import { useProjectStore } from "@/frontend/store/ProjectStore";
import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { ProjectCards } from "../cards/ProjectCards";
import { useShallow } from "zustand/react/shallow";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { CardPlaceholder } from "../cards/CardPlaceholder";
import { ProjectParentType } from "@/backend/models/project";
import { FusawarePermission } from "@/frontend/fusawareUser";
import { I18n } from "@/i18n/I18n";
import { CreateProjectFromTemplateModal } from "./CreateProjectFromTemplateModal";

export function ProjectTemplates(props: { organization: FusaOrganization }) {
  const { organization } = props;
  const fetchProjects = useProjectStore(state => state.fetchProjectsByParentId);
  const projects = useProjectStore(useShallow(state => state.projects.filter(project => project.parentId === organization.id)));
  const canCreateProjects = useGlobalStore(state => Boolean(state.userClass?.fusaHasPermission(FusawarePermission.EDIT_HIERARCHY)));
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);

  useEffect(() => {
    setLoading(true);
    void fetchProjects(organization.id).finally(() => {
      setLoading(false);
    });
  }, [organization.id, fetchProjects]);

  if (loading) return <CardPlaceholder />;

  return (
    <div>
      <ProjectCards
        projects={projects}
        parent={organization}
        parentType={ProjectParentType.ORGANIZATION}
        actions={canCreateProjects && projects.length > 0 && (
          <Button className="btn btn-primary btn-sm" onClick={() => setShowCreateModal(true)}>
            {I18n.get('newProjectFromTemplate')}
          </Button>
        )}
      />
      {showCreateModal && (
        <CreateProjectFromTemplateModal
          templateProjects={projects}
          onClose={() => setShowCreateModal(false)}
        />
      )}
    </div>
  );
}
